/**
 * Precreated voice-agent templates shown on the "Build a Support Agent"
 * wizard. Picked to span the industries/business functions visitors most
 * commonly ask about: general product support, in-person front desk,
 * pre-sales consultation, hospitality, and internal IT helpdesk.
 *
 * Each template's fields map 1:1 onto the wizard's own form state
 * (businessName, industry, task, tone) so clicking one just prefills the
 * form -- the visitor can then edit any field, especially the business
 * name, before continuing.
 */
export const AGENT_TEMPLATES = [
    {
        id: "customer-support",
        icon: "🎧",
        label: "Customer Support",
        description: "General product/order support for any retail or SaaS business.",
        sampleBusinessName: "Northwind Retail",
        industry: "e-commerce / retail support",
        task: "Help customers track orders, process returns or exchanges, and troubleshoot account or billing issues. Escalate anything requiring a refund override or account access change.",
        tone: "friendly",
    },
    {
        id: "front-desk",
        icon: "🛎️",
        label: "Front Desk / Receptionist",
        description: "Greets callers, books appointments, and answers basic office questions.",
        sampleBusinessName: "Harborview Dental",
        industry: "medical/dental clinic front desk",
        task: "Greet callers, schedule or reschedule appointments, confirm office hours and location, and answer basic insurance or intake questions. Do not give medical advice -- offer to have a staff member call back for anything clinical.",
        tone: "professional",
    },
    {
        id: "sales-consultation",
        icon: "💬",
        label: "Sales / Pre-Consultation",
        description: "Qualifies leads and answers product questions before a sales call.",
        sampleBusinessName: "Wanderlust Travel Co.",
        industry: "travel agency",
        task: "Answer questions about vacation packages, gather trip preferences and budget, and set up a pre-consultation call with a travel advisor.",
        tone: "friendly",
    },
    {
        id: "hospitality",
        icon: "🍽️",
        label: "Restaurant & Hospitality",
        description: "Handles reservations, hours, and menu questions for restaurants or hotels.",
        sampleBusinessName: "Cedar & Vine Bistro",
        industry: "restaurant",
        task: "Take table reservations, answer questions about hours, menu, and private events, and handle large-party or special-occasion requests.",
        tone: "casual",
    },
    {
        id: "it-helpdesk",
        icon: "💻",
        label: "IT Helpdesk",
        description: "Internal tech support for password resets, access requests, and tickets.",
        sampleBusinessName: "Meridian Systems IT Desk",
        industry: "internal corporate IT helpdesk",
        task: "Help employees troubleshoot common issues like password resets, VPN access, and software install requests, and open a ticket for anything that needs a technician.",
        tone: "professional",
    },
];
